
<table mat-table [dataSource]="items" class="item-list">

  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let item">
      <div class="item-image">
        <item-thumbnail [item]="item"
            class="item-image"
            (click)="editOnClick && isListed(item) && viewListing(item.id)"
            angulartics2On="click" 
            angularticsAction="ItemIconClick"
            [showFrame]="false"
            [ngStyle]="{'cursor': (isListed(item)) ? 'pointer' : ''}"
        />
      </div>
    </td>
  </ng-container>
  
  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let item">
      <div class="title" *ngIf="editOnClick && isListed(item)"><a [routerLink]="['/view-listing/', item.id]">{{item.title}}</a></div>
      <div class="title" *ngIf="!(editOnClick && isListed(item))">{{item.title}}</div>
      <div class="subtitle">
        <div>{{item.description}}</div>
        <div>
          <span>{{item.dateOfPurchase | date}}</span>
          <span *ngIf="item.purchasedInShop"> - {{item.purchasedInShop}}</span>
        </div>
      </div>
      <div *ngIf="item.purchasePriceEUR"><ng-container i18n>Purchase price</ng-container>: <span class="price">{{item.purchasePriceEUR!.toNumber() | currency : item.purchasePriceEUR!.currency()}}</span></div>
      <div *ngIf="showPrice && item.priceEUR"><ng-container i18n>Price</ng-container>: <span class="price">{{item.priceEUR!.toNumber() | currency : item.priceEUR!.currency()}}</span></div>
    </td>
  </ng-container>
  
  <ng-container matColumnDef="xsDetails">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let item">
      <div class="title" *ngIf="editOnClick && isListed(item)"><a [routerLink]="['/view-listing/', item.id]">{{item.title}}</a></div>
      <div class="title" *ngIf="!(editOnClick && isListed(item))">{{item.title}}</div>
      <div class="subtitle">
        <div *ngIf="item.purchasedInShop">
          <span i18n>from {{item.purchasedInShop}}</span>
        </div>
      </div>
      <div *ngIf="item.purchasePriceEUR"><ng-container i18n>Purchase price</ng-container>: <span class="price">{{item.purchasePriceEUR!.toNumber() | currency : item.purchasePriceEUR!.currency()}}</span></div>
      <div *ngIf="showPrice && item.priceEUR"><ng-container i18n>Price</ng-container>: <span class="price">{{item.priceEUR!.toNumber() | currency : item.priceEUR!.currency()}}</span></div>
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start;">
        <button (click)="createListing(item)" 
              *ngIf="isReadyForLisitng(item)" 
              mat-raised-button 
              angulartics2On="click" 
              angularticsAction="ListForSaleClick" 
              color="accent" i18n>LIST FOR SALE</button>
            
        <button (click)="editListing(item.id)" 
            *ngIf="isListed(item)" 
            mat-stroked-button 
            angulartics2On="click" 
            angularticsAction="EditListingClick" i18n>EDIT LISTING</button> 
        
        <universal-share-button
            *ngIf="isListed(item)" 
            [url]="getItemURL(item)" 
            [analyticsCategory]="'' + item.id" 
            [title]="item.title" 
            [description]="item.description">
        </universal-share-button>
        
        <button *ngIf="isDraft(item)" mat-stroked-button (click)="editListing(item.id)" color="primary" disabled>
          <span class="with-spinner">
            <mat-spinner [diameter]="16"></mat-spinner>
            <span i18n>AI PROCESSING</span>
          </span>
        </button>
        
        <button mat-icon-button (click)="deleteItem(item)" *ngIf="!isListed(item)">
          <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>
  
  <ng-container matColumnDef="titleAndImage">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let item">
      <div class="item-image">
        <item-thumbnail [item]="item"
            (click)="editOnClick && isListed(item) && viewListing(item.id)"
            angulartics2On="click" 
            angularticsAction="ItemIconClick"
            [showFrame]="false"
            [ngStyle]="{'cursor': (isListed(item)) ? 'pointer' : ''}"
        />
      </div>
    
      <div class="title" *ngIf="editOnClick && isListed(item)"><a [routerLink]="['/view-listing/', item.id]">{{item.title}}</a></div>
      <div class="title" *ngIf="!(editOnClick && isListed(item))">{{item.title}}</div>
      <div class="subtitle">
        <div>
          <span>{{item.dateOfPurchase | date}}</span>
          <span *ngIf="item.purchasedInShop"> - {{item.purchasedInShop}}</span>
        </div>
      </div>
      <div *ngIf="item.purchasePriceEUR"><ng-container i18n>Purchase price</ng-container>: <span class="price">{{item.purchasePriceEUR!.toNumber() | currency : item.purchasePriceEUR!.currency()}}</span></div>
    </td>
  </ng-container>
  
  <ng-container matColumnDef="purchasePrice">
    <th mat-header-cell *matHeaderCellDef i18n>Purchase price</th>
    <td mat-cell *matCellDef="let item" class="price">{{item.purchasePriceEUR?.toNumber() | currency : item.purchasePriceEUR?.currency()}}</td>
  </ng-container>
  
  <ng-container matColumnDef="createListing">
    <th mat-header-cell *matHeaderCellDef>
    </th>
    <td mat-cell *matCellDef="let row">
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-end;">
      
        <button (click)="createListing(row)" 
            *ngIf="isReadyForLisitng(row)" 
            mat-raised-button 
            angulartics2On="click" 
            angularticsAction="ListForSaleClick" 
            color="accent" i18n>LIST FOR SALE</button>
          
        <button (click)="editListing(row.id)" 
            *ngIf="isListed(row)" 
            mat-stroked-button 
            angulartics2On="click" 
            angularticsAction="EditListingClick" i18n>EDIT LISTING</button> 
        
        <div *ngIf="isListed(row)">
          <universal-share-button 
              [url]="getItemURL(row)" 
              [analyticsCategory]="'' + row.id" 
              [title]="row.title" 
              [description]="row.description">
          </universal-share-button>
        </div>
        
        <button *ngIf="isDraft(row)" mat-stroked-button (click)="editListing(row.id)" color="primary" disabled>
          <span class="with-spinner">
            <mat-spinner [diameter]="16"></mat-spinner>
            <span i18n>AI PROCESSING</span>
          </span>
        </button>
        
        <button mat-icon-button (click)="deleteItem(row)" *ngIf="!isListed(row)">
          <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>
  
  <ng-container *ngIf="needsHeader">
    <tr mat-header-row  *matHeaderRowDef="columnsToDisplay; sticky: false"></tr>
  </ng-container>
  <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
</table>
